import React from 'react';
import {__GPYPost,_GPY,__GPYGetI18nValues} from './env.js'
import $ from "jquery";

class I18nString extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
					subset:[],
					back:[],
 			};
	}

	openTransLateWindow(){
		if(_GPY.uiStates.userLvl === undefined || _GPY.uiStates.userLvl < 600)return;

	  var prefix = this.props.prefix;
		if( this.props.scoreboard !== undefined ) {
			prefix = "gametype_" + this.props.scoreboard.state.gameMenuInView;
		}

		var k = [];
		var back = [];
		var pre = prefix.split("|");
		Object.keys(_GPY.i18n).forEach(key => {
			for (var i = 0; i<pre.length;i++) {
					if(key.toLowerCase().startsWith(pre[i].toLowerCase())) {
						k.push({k:key,v:_GPY.i18n[key]});
						back.push({k:key,v:_GPY.i18n[key]});
					}
			}
		});

		this.setState({subset:k ,back:back},()=> {
			this.show();
		});
	}

  onChange(i,e) {
				i.v = e.target.value;
				console.log(this.state.subset);
  }

	save(){
		if(_GPY.uiStates.userLvl === undefined || _GPY.uiStates.userLvl < 600)return;

		for(var i = 0 ;i<this.state.subset.length;i++) {
				var item = this.state.subset[i];
				if(item.v!==this.state.back[i].v) {
						console.log("STORE:" ,item);
					  __GPYPost('changeI18nValue', {key:item.k, lang:_GPY.locale, value:item.v} );
				}
		}
		__GPYGetI18nValues();
		if(this.props.callBack !== undefined){
			this.props.callBack();
		}
		this.hide();
	}

	show(){
		 $(this.modal).modal('show');
	}

	hide(){
		 $(this.modal).modal('hide');
	}


  render() {
		if(_GPY.uiStates.userLvl === undefined || _GPY.uiStates.userLvl < 600){
			return "";
		}

		return (<div>
	 				<div className="modal fade" ref={modal => this.modal = modal} tabIndex="-1" role="dialog" aria-labelledby="gpyModalLabel" aria-hidden="true">
					 	<div className="modal-dialog modal-lg" role="document">
					  	 <div className="modal-content">
							 <div className="modal-header"><h5 className="modal-title">Translate to [{_GPY.locale}]</h5></div>
								 <div className="modal-body">

				{	this.state.subset.map( (i) => {
					return (
						<div key={i.k} className="row">
							<div className="col-12">{i.k}</div>
							<div className="col-12"><div className="form-group"><input name="login_password" className="form-control" onChange={this.onChange.bind(this,i)} defaultValue={i.v} type="text"/></div></div>
						</div>

				)})
				}
					<div className="row">
						<div className="col-6 text-left"><button onClick={this.hide.bind(this)} className="btn btn-light">cancel</button></div>
						<div className="col-6 text-right"><button onClick={this.save.bind(this)} className="btn btn-primary">save</button></div>
					</div>
				</div>
			</div>
		 </div>
		</div>

		<button type="button" className="btn btn-link" onClick={this.openTransLateWindow.bind(this)}><img alt={"flag "+_GPY.locale} src={_GPY.resource("images/flags/"+_GPY.locale+".png")}/></button>
		</div>
		);
  }
}
export default I18nString;
